<div *ngIf="viewsModel?.views" class="wrap-menu">
    <ng-container *ngIf="viewsModel.views.length">
        <div class="menu-items">
            <!-- one node for both sides (VAR/FOR is a switch on the page); the forecast walk tabs hang under it -->
            <div [ngClass]="{'active': isViewingProjectOverview || (isViewingForecastWalk && mainFcstWalkModel?.selectedTabIx === undefined)}" class="menu-item">
                <div class="wrap-text">
                    <a [routerLink]="['/project-overview']"
                       [queryParams]="getProjectOverviewQueryParams()"
                       [queryParamsHandling]="'merge'">
                        <div class="subtitle-1">Project overview</div>
                        <div class="subtitle-2">{{viewsModel.views[0].outcomeName}}</div>
                    </a>
                </div>
                <div class="wrap-button">
                    <button [matMenuTriggerFor]="projectMenu" class="btn btn-icon btn-transparent btn-small"><span class="material-icons-outlined">more_horiz</span></button>
                </div>
                <mat-menu #projectMenu="matMenu">
                    <button mat-menu-item (click)="onDuplicateProjectOverview()">Duplicate</button>
                </mat-menu>
            </div>
            <div *ngIf="mainFcstWalkModel?.tabsTree?.length" class="menu-items">
                <ng-container *ngTemplateOutlet="fcstWalkTree; context:{ levelNodes: mainFcstWalkModel.tabsTree }">
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-template #fcstWalkTree let-levelNodes="levelNodes">
        <ng-container *ngFor="let node of levelNodes; let nodeIndex = index">
            <div [ngClass]="{'active': isActiveFcstWalkNode(node)}" class="menu-item">
                <div class="wrap-text">
                    <a [routerLink]="['/project-overview']"
                       [queryParams]="getFcstWalkTabQueryParams(node)"
                       [queryParamsHandling]="'merge'"
                       class="body-2">
                        {{ node.tab.header ? node.tab.driverTypeName + ': ' + node.tab.header : node.tab.driverTypeName }}
                    </a>
                </div>
                <div class="wrap-button">
                    <button [matMenuTriggerFor]="fcstNodeMenu" class="btn btn-icon btn-transparent btn-small"><span class="material-icons-outlined">more_horiz</span></button>
                </div>
                <mat-menu #fcstNodeMenu="matMenu">
                    <button mat-menu-item (click)="onDeleteFcstNodeClick(node)">Delete</button>
                </mat-menu>
            </div>
            <div class="menu-items" *ngIf="node.children?.length">
                <ng-container *ngTemplateOutlet="fcstWalkTree; context:{ levelNodes: node.children }">
                </ng-container>
            </div>
        </ng-container>
    </ng-template>

    <div class="section-title">
        <span class="subtitle-3">Views</span>
    </div>
    <ng-template #tabsTree let-levelTabs="levelTabs" let-view="view">
        <ng-container *ngFor="let tab of levelTabs">
            <div [ngClass]="{'active': !isViewingForecastWalk && !isViewingProjectOverview && view.viewId == cardsModel.viewId && view.selectedTabId === tab.id}" class="menu-item">
                <div class="wrap-text">
                    <a [routerLink]="getTabQueryParams(view, tab) ? ['/cards'] : null"
                       [queryParams]="getTabQueryParams(view, tab)"
                       [queryParamsHandling]="'merge'"
                       class="body-2">
                        {{ tab.header ? tab.driverTypeName + ': ' + tab.header : tab.driverTypeName }}
                    </a>
                </div>
                <div *ngIf="copiedTab && tab.isMarkedCompatible && !isSelectedForCopying(view, tab)" class="wrap-compatible-icon">
                    <span class="material-icons-outlined">library_add</span>
                </div>
                <div *ngIf="isSelectedForCopying(view, tab)" class="wrap-compatible-icon wrap-close-icon" (click)="onCancelCopyMode()">
                    <span class="material-icons-outlined">close</span>
                </div>
                <div *ngIf="!copiedTab" class="wrap-button">
                    <button [matMenuTriggerFor]="tabMenu" class="btn btn-icon btn-transparent btn-small"><span class="material-icons-outlined">more_horiz</span></button>
                </div>
                <mat-menu #tabMenu="matMenu">
                    <button mat-menu-item (click)="onSelectTabForCopying(view, tab)">Copy</button>
                    <button mat-menu-item (click)="onDeleteTabClick(view.viewId, tab.id)">Delete</button>
                </mat-menu>
            </div>
            <div class="menu-items" *ngIf="tab.children?.length">
                <ng-container *ngTemplateOutlet="tabsTree; context:{ levelTabs: tab.children, view: view }">
                </ng-container>
            </div>
        </ng-container>
    </ng-template>

    <div *ngFor="let view of viewsModel.views" [ngClass]="{'with-divider': view.isDefault }" class="menu-items">
        <div [ngClass]="{'active': !isViewingForecastWalk && !isViewingProjectOverview && view.viewId == cardsModel.viewId && view.selectedTabId === undefined}" class="menu-item">
            <div class="wrap-text">
                <a [routerLink]="getMainTabQueryParams(view) ? ['/cards'] : null"
                   [queryParams]="getMainTabQueryParams(view)"
                   [queryParamsHandling]="'merge'">
                    <div class="subtitle-1">{{view.name}}</div>
                    <div class="subtitle-2">{{view.driverTypeName}}</div>
                </a>
            </div>
            <div *ngIf="copiedTab && view.mainTabIsMarkedCompatible && !isSelectedForCopying(view)" class="wrap-compatible-icon">
                <span class="material-icons-outlined">library_add</span>
            </div>
            <div *ngIf="isSelectedForCopying(view)" class="wrap-compatible-icon wrap-close-icon" (click)="onCancelCopyMode()">
                <span class="material-icons-outlined">close</span>
            </div>
            <div *ngIf="!copiedTab" class="wrap-button">
                <button [matMenuTriggerFor]="viewMenu" class="btn btn-icon btn-transparent btn-small"><span class="material-icons-outlined">more_horiz</span></button>
            </div>
            <mat-menu #viewMenu="matMenu">
                <button mat-menu-item (click)="renameView(view)">Rename</button>
                <button mat-menu-item (click)="onDuplicateView(view)">Duplicate</button>
                <button mat-menu-item (click)="onSelectTabForCopying(view)">Copy</button>
                <button mat-menu-item (click)="onDeleteView(view)">Delete</button>
            </mat-menu>
        </div>
        <div class="menu-items">
            <ng-container *ngTemplateOutlet="tabsTree; context:{ levelTabs: view.hierarchicalTabs, view: view }">
            </ng-container>
        </div>
    </div>
</div>
